<template>
    <div class="row flex-column">
        <div class="bg-image">
            <div class="bg-light">
                <div class="content content-full">
                    <div class="d-flex justify-content-between align-items-center">
                        <h1 class="flex-fill font-size-h2 my-2">
                            Edit Project
                        </h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="block">
            <div class="block-content">
                <form ref="createProject">
                    <div class="col-sm-8 offset-sm-2">
                        <div class="form-group">
                            <label for="project-name">Project Name</label>
                            <input :class="{'is-invalid': errors.name}" class="form-control" id="project-name"
                                   v-model="project.name" autocomplete="off"
                                   placeholder="Give your project a cool name">
                            <div v-if="errors.name" :class="['invalid-feedback']">
                                {{errors.name[0]}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Billing Account</label>
                            <select :class="{'is-invalid': errors.account}"
                                    v-model="project.account"
                                    class="form-control">
                                <option
                                    v-if="includes(['credit', 'unit'], account.account_type)"
                                    :value="account.id" v-for="(account, key) in accounts.data"
                                    :key="key">{{account.name}} ({{account.account_type}})
                                </option>
                            </select>
                            <div v-if="errors.account" :class="['invalid-feedback']">
                                {{errors.account[0]}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="description">Project Description</label>
                            <textarea id="description" v-model="project.description" class="form-control"
                                      placeholder="What is the purpose of the project"
                                      rows="3"/>
                        </div>
                        <div class="form-group">
                            <button :disabled="updateProjectStatus" class="btn btn-hero-primary float-right"
                                    @click.prevent="updateProject">
                                Save Changes
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import EventBus from '../../bus/events';
    import includes from 'lodash/includes'

    export default {
        name: "UpdateProject",
        data() {
            return {
                includes : includes
            }
        },
        computed: {
            ...mapGetters({
                updateProjectStatus: 'getUpdateProjectStatus',
                accounts: 'getAccounts',
                project: 'getProject',
                errors: 'getProjectValidationErrors',
            })
        },
        mounted() {
            this.$store.dispatch('getBillingAccounts');
            this.$store.dispatch('findProject', this.$route.params);
        },
        methods: {
            updateProject() {
                this.$store.dispatch('updateProject', this.project).then(() => {
                    EventBus.$on('project-updated', (project) => {
                        this.$router.push('/dashboard');
                    });
                });

            }
        }
    }
</script>

<style scoped>
    .style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__dropdown-menu {
        background: #dfe5fb;
        border: none;
        color: #394066;
        text-transform: lowercase;
        font-variant: small-caps;
    }

    .style-chooser .vs__clear,
    .style-chooser .vs__open-indicator {
        fill: #394066;
    }
</style>
